import { pictureElements, aiImages, aiBgElements } from './state.mjs';
import { imageTransform } from '../processors/image-transform.mjs';
import { backgroundTransform } from '../processors/background-transform.mjs';
import { pictureTransform } from '../processors/picture-transform.mjs';
import { imageUpdate } from '../processors/image-update.mjs';
import { invalidateMeasurementCache } from '../utils/cache.mjs';

/**
 * Initialise système optimisation images + gestion resize
 */
export async function init() {
    // Scanner DOM
    const newPictureElements = Array.from(document.querySelectorAll('picture'));
    // Le PHP traite maintenant toutes les images ai-src, donc le JavaScript n'a plus besoin de les traiter
    const newAiImages = []; // Vide - toutes les images sont traitées par le PHP
    const newAiBgElements = Array.from(document.querySelectorAll('[ai-bg-src]'));

    // Mettre à jour les tableaux exportés
    pictureElements.length = 0;
    pictureElements.push(...newPictureElements);

    aiImages.length = 0;
    aiImages.push(...newAiImages);

    aiBgElements.length = 0;
    aiBgElements.push(...newAiBgElements);

    // Traiter seulement les pictures avec JavaScript (pour les comportements dynamiques)
    if (pictureElements.length) await pictureTransform();
    // Plus besoin de traiter les images simples - géré par le PHP
    // if (aiImages.length) await imageTransform();
    if (aiBgElements.length) await backgroundTransform();

    setTimeout(() => imageUpdate(true), 10);

    // Gestion resize avec debounce
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        invalidateMeasurementCache();
        resizeTimer = setTimeout(() => imageUpdate(false), 250);
    });
}
